export default __webpack_public_path__ + "static/media/weatherapp.38123bd6.png";